import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTaskLocked = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 261.892,
	height: 223.318,
	viewBox: "0 0 261.892 223.318",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_14585",
				"data-name": "Rectangle 14585",
				width: 209.966,
				height: 212.805,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-3",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15201",
				"data-name": "Path 15201",
				d: "M57.07,366.875v132.34c0,3.672,3.27,6.468,7.27,6.234l188.818-11.032a6.087,6.087,0,0,0,5.538-6.11V373.318a5.924,5.924,0,0,0-5.538-5.987L64.34,360.479c-.1,0-.194-.005-.29-.005-3.867,0-6.98,2.818-6.98,6.4",
				transform: "translate(-57.07 -360.474)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient",
			x1: .013,
			y1: 1.188,
			x2: .013,
			y2: 1.188,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#26264f"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .004,
					stopColor: "#26264f"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#444b8c"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-4",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15202",
				"data-name": "Path 15202",
				d: "M1126.083,2137.835l-4.625,23.762c-.648,3.328,1.945,6.667,4.931,7.893l15.721,6.453a19.56,19.56,0,0,0,9.191,1.4l33.224-2.982a2.111,2.111,0,0,0,1.863-1.916c.113-1.028.794-2.182-.133-2.5l-12.294-3.654a9.218,9.218,0,0,1-5.91-7.041l-4.393-22.809Z",
				transform: "translate(-1121.359 -2136.436)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-2",
			x1: -1.097,
			y1: .963,
			x2: -1.096,
			y2: .963,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#444b8c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#26264f"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#26264f"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-5",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15203",
				"data-name": "Path 15203",
				d: "M1143.452,2123.97l-4.62,23.463a6.933,6.933,0,0,0,4.048,7.792l15.7,6.372a19.751,19.751,0,0,0,9.182,1.381l33.19-2.945a2.1,2.1,0,0,0,1.861-1.892,2.155,2.155,0,0,0-1.4-2.291l-11.018-3.79a9.131,9.131,0,0,1-5.9-6.952l-4.388-22.522Z",
				transform: "translate(-1138.696 -2122.586)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-3",
			x1: -1.12,
			y1: 1.222,
			x2: -1.119,
			y2: 1.222,
			xlinkHref: "#linear-gradient-2"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-6",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15204",
				"data-name": "Path 15204",
				d: "M77.528,366.875v132.34c0,3.672,3.27,6.468,7.27,6.234l188.818-11.032a6.087,6.087,0,0,0,5.538-6.11V373.318a5.924,5.924,0,0,0-5.538-5.987L84.8,360.479c-.1,0-.194-.005-.29-.005-3.867,0-6.98,2.818-6.98,6.4",
				transform: "translate(-77.528 -360.474)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-4",
			x1: .046,
			y1: .958,
			x2: .046,
			y2: .958,
			xlinkHref: "#linear-gradient-2"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-7",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15205",
				"data-name": "Path 15205",
				d: "M123.961,406.155V538.2a3.485,3.485,0,0,0,3.877,3.333l188.818-10.651a3.249,3.249,0,0,0,2.966-3.266V412.408a3.162,3.162,0,0,0-2.966-3.2l-188.818-6.471-.147,0a3.561,3.561,0,0,0-3.73,3.421",
				transform: "translate(-123.961 -402.734)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-5",
			x1: -.059,
			y1: .999,
			x2: -.058,
			y2: .999,
			xlinkHref: "#linear-gradient-2"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-8",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15206",
				"data-name": "Path 15206",
				d: "M156.343,433.648V556.392a1.371,1.371,0,0,0,1.511,1.31l188.818-9.263a1.26,1.26,0,0,0,1.159-1.268v-107.4a1.236,1.236,0,0,0-1.159-1.249l-188.818-6.2H157.8a1.392,1.392,0,0,0-1.456,1.335",
				transform: "translate(-156.343 -432.313)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-6",
			x1: -.056,
			y1: 1.024,
			x2: -.055,
			y2: 1.024,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#ebeff2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .494,
					stopColor: "#ebeff2"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#fff"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-9",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15207",
				"data-name": "Path 15207",
				d: "M290.367,530.133l174.105,4.04V526.7l-174.105-5.005Z",
				transform: "translate(-290.367 -521.694)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-7",
			x1: -2.754,
			y1: 1.466,
			x2: -2.752,
			y2: 1.466,
			xlinkHref: "#linear-gradient-2"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-10",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15208",
				"data-name": "Path 15208",
				d: "M2466.338,624a.984.984,0,0,0,.94.991.924.924,0,0,0,.939-.942.984.984,0,0,0-.939-.991h-.024a.925.925,0,0,0-.916.943",
				transform: "translate(-2466.338 -623.061)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-8",
			x1: -70.177,
			y1: 66.213,
			x2: -70.149,
			y2: 66.213,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#ff9085"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fb6fbb"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-11",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15209",
				"data-name": "Path 15209",
				d: "M2519.216,625.411a.98.98,0,0,0,.935.988.92.92,0,0,0,.934-.94.98.98,0,0,0-.934-.988h-.024a.921.921,0,0,0-.91.94",
				transform: "translate(-2519.216 -624.471)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-9",
			x1: -71.954,
			y1: 66.486,
			x2: -71.925,
			y2: 66.486,
			xlinkHref: "#linear-gradient-8"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-12",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15210",
				"data-name": "Path 15210",
				d: "M2571.795,626.81a.976.976,0,0,0,.929.986.917.917,0,0,0,.928-.937.976.976,0,0,0-.928-.986h-.024a.917.917,0,0,0-.905.938",
				transform: "translate(-2571.795 -625.872)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-10",
			x1: -73.732,
			y1: 66.76,
			x2: -73.704,
			y2: 66.76,
			xlinkHref: "#linear-gradient-8"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-19",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15289",
				"data-name": "Path 15289",
				d: "M1791.661,1933.492c-6.632,11-10.708,4.671-18.952,2.047-11.255-3.582-9.089,10.2-15.638,12.141-2.218.657-2.942.4-5.1.03a5.077,5.077,0,0,1-2.023-.282c-.993-.243-2-.487-2.246-.177a5.806,5.806,0,0,0-.571.88l1.343,6.895a9.132,9.132,0,0,0,5.9,6.952l11.019,3.79a2.039,2.039,0,0,1,.881.6,19.757,19.757,0,0,1,2.455,1.334c5.227,3.44,17.1,9.877,19.785,1.11,2.237-7.3.712-12.673,9.989-11.767s15.54-2.383,16.817-10.819c1.344-8.877,14.057-13.273,10.645-21.933-1.914-4.858-5.463-6.775-9.618-6.775-8.754,0-20.2,8.512-24.693,15.973",
				transform: "translate(-1747.135 -1917.519)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-20",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15295",
				"data-name": "Path 15295",
				d: "M1784.79,1933.479c-6.617,10.992-10.758,4.707-18.945,2.042-11.177-3.639-9.3,10.352-15.556,12.074-4.905,1.349-6.586-.7-10.515-2.441l-.057.186,1.885,9.676a9.13,9.13,0,0,0,5.9,6.952l4.939,1.7a29.539,29.539,0,0,1,5.556,1.911l.524.18a2.02,2.02,0,0,1,.677.395,26.119,26.119,0,0,1,2.674,1.536c5.187,3.453,17.092,9.875,19.771,1.112,2.23-7.294.712-12.673,9.988-11.766s15.538-2.384,16.816-10.819c1.346-8.877,14.054-13.27,10.644-21.933-1.912-4.858-5.461-6.775-9.615-6.775-8.756,0-20.2,8.517-24.691,15.971",
				transform: "translate(-1739.718 -1917.508)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-21",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15296",
				"data-name": "Path 15296",
				d: "M1826.478,1593.059c-4.608,0-10.034,2.505-12.55,6.341a8.824,8.824,0,0,0-1.072,2.254,64.417,64.417,0,0,1-4.611,9.671c-4.481,7.876-10.079,13.853-14.5,10.376a6.136,6.136,0,0,0-5.3-1.634c-2.537.715-4.564,3.027-5.841,6.08a18.856,18.856,0,0,0-.8,2.358,20.9,20.9,0,0,0-.533,2.735c-.873,5.292.386,15.667-11.9,20l-.019.007-.006,0-.013,0-.008,0-.011,0-.008,0-.011,0-.008,0-.01,0-.008,0-.011,0-.008,0-.011,0-.008,0-.011,0-.008,0-.011,0-.008,0-.011,0-.008,0-.011,0-.007,0-.012,0-.007,0-.012,0-.006,0-.013.005-.006,0-.013.005-.005,0-.014.005,0,0-.015.006h0l-.017.007h0a11.922,11.922,0,0,0-3.926,2.749l.031.157a9.131,9.131,0,0,0,5.9,6.952l9.822,3.378a14.486,14.486,0,0,0,2.877-7.425h0c0-.013,0-.026.005-.039v0l0-.017v0c0-.006,0-.011,0-.017v0c0-.005,0-.011,0-.016v0l0-.016v-.005s0-.01,0-.015v0c0-.005,0-.011,0-.016a.024.024,0,0,1,0,0c0-.005,0-.01,0-.015V1657a.108.108,0,0,1,0-.014.054.054,0,0,0,0-.006c0-.005,0-.011,0-.016v0c0-.006,0-.012,0-.017v0c0-.006,0-.012,0-.019h0c0-.02,0-.04.007-.06a.009.009,0,0,1,0,0c0-.006,0-.012,0-.017v0l0-.015v-.008s0-.008,0-.012v-.007s0-.008,0-.012a.069.069,0,0,1,0-.009v-.011s0-.006,0-.009,0-.007,0-.01v-.01s0-.007,0-.011v-.008s0-.009,0-.013v-.008s0-.008,0-.011v-.028s0-.009,0-.014v-.005s0-.01,0-.015v-.036l0-.018,0-.032a.052.052,0,0,0,0-.007v-.021a.1.1,0,0,0,0-.011v-.01s0-.007,0-.011v-.019s0-.007,0-.01v-.03s0-.007,0-.01v-.041s0-.006,0-.01v-.091c0-.007,0-.014,0-.02.776-7.139,8.96-7.137,16.52-9.155,8.831-2.1,3.879-10.891,10.256-15.156,6.488-4.349,19.2-6.989,23.266-20.351a26.882,26.882,0,0,0,1.748-8.825c0-5.635-2.85-8.751-6.96-9.484q-.253-.051-.512-.089h-.021l-.014,0h0q-.5-.073-1.027-.1h-.034q-.288-.014-.581-.014h0",
				transform: "translate(-1765.101 -1593.059)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-22",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15304",
				"data-name": "Path 15304",
				d: "M1812.855,1601.653c-4.526,11.417-12.959,24.886-19.11,20.047-6.225-5.134-11.529,1.926-12.474,9.54-.873,5.292.386,15.667-11.9,20a11.67,11.67,0,0,0-4.268,2.881l.031.157a9.131,9.131,0,0,0,5.9,6.952l9.822,3.378a15.174,15.174,0,0,0,2.983-8.367c.776-7.139,8.96-7.137,16.52-9.154,8.831-2.1,3.879-10.891,10.256-15.157,6.488-4.349,19.2-6.989,23.266-20.351,3.986-11.29.691-17.256-5.212-18.309a11.084,11.084,0,0,0-2.192-.209c-5.458,0-12.066,3.516-13.622,8.595",
				transform: "translate(-1765.1 -1593.058)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-23",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37943",
				"data-name": "Path 37943",
				d: "M503.669,2714.074c-.036.619-6.9.935-6.97.471s1.135-1.2,1.982-1.46,3.328-.954,3.328-.954l1.412-.414a17.946,17.946,0,0,1,.248,2.356",
				transform: "translate(-496.696 -2711.717)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-11",
			x1: -7.489,
			y1: -.058,
			x2: -7.474,
			y2: -.058,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#311944"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#893976"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-24",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37944",
				"data-name": "Path 37944",
				d: "M496.11,2686.927a1.561,1.561,0,0,1-1.5-.12l-.219-2.161,2.07-.071Z",
				transform: "translate(-494.391 -2684.574)",
				fill: "#f7cfa8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-25",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37945",
				"data-name": "Path 37945",
				d: "M319.374,2756.472c-.036.618-6.9.935-6.97.471s1.135-1.2,1.982-1.46,3.327-.954,3.327-.954l1.412-.413a17.93,17.93,0,0,1,.248,2.356",
				transform: "translate(-312.401 -2754.115)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-12",
			x1: -4.809,
			y1: .315,
			x2: -4.794,
			y2: .315,
			xlinkHref: "#linear-gradient-11"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-26",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37946",
				"data-name": "Path 37946",
				d: "M311.817,2729.325a1.561,1.561,0,0,1-1.5-.121l-.219-2.161,2.07-.071Z",
				transform: "translate(-310.098 -2726.972)",
				fill: "#f7cfa8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-27",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37947",
				"data-name": "Path 37947",
				d: "M382.139,1836.167c-1.67,8.99-4.8,10.984-4.954,18.458-.116,5.766,1.71,6.566,1.534,12.589a32.192,32.192,0,0,1-3.561,13.538l-3.227.148c-.61-7.062-1.034-14.586-1.186-22.528-.2-10.675.113-20.657.751-29.836l2.38-4.826,8.82-.92a48.141,48.141,0,0,1-.557,13.376",
				transform: "translate(-370.684 -1822.79)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-13",
			x1: -1.277,
			y1: -.109,
			x2: -1.273,
			y2: -.109,
			xlinkHref: "#linear-gradient-2"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-28",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37949",
				"data-name": "Path 37949",
				d: "M239.065,1847.448c1.315,1.36,1.3,3.69,1.2,8.3-.1,4.907-.776,6.307-1.334,12.722a64.866,64.866,0,0,0-.347,8.558,58.747,58.747,0,0,0,1.121,9.224c.671,4.063.387,10.3-4.266,19.508l-3.542-.1c-.26-9.742-.921-20.235-2.161-31.366-1.026-9.218-2.342-17.91-3.831-26.032.477-.222,5.013-2.275,8.886-2.275a5.76,5.76,0,0,1,4.271,1.465",
				transform: "translate(-225.908 -1845.983)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-14",
			x1: -.655,
			y1: -.052,
			x2: -.651,
			y2: -.052,
			xlinkHref: "#linear-gradient-2"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-29",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37952",
				"data-name": "Path 37952",
				d: "M178.189,1848.527a3.82,3.82,0,0,1,2.03,1.254l1.631-1.042-.043,1.21c-.1.106-1.294,1.315-1.989,1.045a2.318,2.318,0,0,1-.291-.15,3.179,3.179,0,0,1-.761-.678c-.421-.418-1.193-.1-2.234-.483-.129-.048-.963-.355-.937-.66s.837-.582,1.754-.582a3.954,3.954,0,0,1,.84.087",
				transform: "translate(-175.594 -1848.44)",
				fill: "#f7cfa8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-30",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37897",
				"data-name": "Path 37897",
				d: "M850.934,1535.219c-.16.106-.321.212-.479.319q.2-.4.395-.817l.084.5",
				transform: "translate(-850.455 -1534.722)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-15",
			x1: -59.544,
			y1: -97.803,
			x2: -59.473,
			y2: -97.803,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#aa80f9"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#6165d7"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#6165d7"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-31",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37941",
				"data-name": "Path 37941",
				d: "M945.036,1230.523c1.039.058,1.645,2.107,1.645,2.107,2.344,3.261-1.336,1.145-3.092.693s-.972-2.263-.972-2.263-1.621-.363-2.083-1.286c-.1-.2.01-.284.259-.284.875,0,3.434.99,4.243,1.035",
				transform: "translate(-940.496 -1229.488)",
				fill: "#f7cfa8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-32",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37942",
				"data-name": "Path 37942",
				d: "M428.367,1273.98c3.868.531,7.259.172,8.346-.495,5.687-3.487,6.7-3.417,7.27-3.347.275.034.444.068.993-.307,1.145,1.379,7.4,9.081,5.009,13.406-2.679,4.847-14.841,2.965-21.837-.038a30.665,30.665,0,0,1-9.583-6.557,30.069,30.069,0,0,1-5.047-6.872l1.445-3.216a22.7,22.7,0,0,0,13.405,7.425",
				transform: "translate(-413.517 -1266.556)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-16",
			x1: -.532,
			y1: -2.29,
			x2: -.53,
			y2: -2.29,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#ffc444"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#f36f56"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#f36f56"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-33",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37950",
				"data-name": "Path 37950",
				d: "M136.73,1308.7c5.765.3,8.648.452,10.8,1.584.315.166,6.855,3.723,7.3,9.522.458,5.9-5.969,6.695-6.826,14.565-.385,3.533.3,8.967.746,12.491.427,3.384.721,4.25.053,5.275-1.61,2.469-6.537,1.766-16.393.358-3.866-.552-5.53-.992-6.374-2.393-1.131-1.877.29-3.687.613-7.244.367-4.031-1.186-4.7-2.722-11.382-1.021-4.443-2-8.707-.831-13.7.561-2.393,1.512-6.451,4.87-8.411a8.475,8.475,0,0,1,4.393-.829c1.191,0,2.618.071,4.368.163",
				transform: "translate(-122.566 -1308.541)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-17",
			x1: .5,
			y1: 1,
			x2: .5,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#f36f56"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#fb6fbb"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-34",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37953",
				"data-name": "Path 37953",
				d: "M17.723,1348V1348a15.525,15.525,0,0,1-.523,4.033c-2.016,7.5-9.351,11.149-10.987,11.917l-1.142-2.6c1.9-2.111,4.033-5.234,3.731-8.8-.419-4.939-5.178-6.625-7.567-12.347-1.18-2.826-2-7.154-.134-13.58,10.517,4.144,16.621,13.151,16.622,21.364",
				transform: "translate(0 -1326.632)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-18",
			x1: .278,
			y1: -1.778,
			x2: .279,
			y2: -1.778,
			xlinkHref: "#linear-gradient-16"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-35",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37954",
				"data-name": "Path 37954",
				d: "M317.911,1227.258c.6,1.454,3.772,2.368,4.415,2.693s-1.2,1.273-3.058,1.46-7.149-.235-8.1-.937.767-.65,2.091-1.136,2.089-3.074,1.855-4.249,2.037-1.587,2.037-1.587a13.147,13.147,0,0,0,.764,3.757",
				transform: "translate(-310.888 -1223.501)",
				fill: "#f7cfa8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-36",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37955",
				"data-name": "Path 37955",
				d: "M360.335,1135.91c.29.33-.137.785.066,1.42.19.595.706.639,1.661,1.419.787.642,1.276,1.042,1.389,1.6a2.739,2.739,0,0,1-2.41,2.791c-.446-.016-.568-.245-2.742-2.38-.962-.945-1.1-1.056-1.2-1.382a3.148,3.148,0,0,1,1.931-3.549,2.577,2.577,0,0,1,.722-.123.758.758,0,0,1,.583.2",
				transform: "translate(-357.003 -1135.708)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-19",
			x1: -2.438,
			y1: -11.534,
			x2: -2.431,
			y2: -11.534,
			gradientUnits: "objectBoundingBox",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					stopColor: "#444b8c"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .996,
					stopColor: "#3e4177"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#3e4177"
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-37",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_37956",
				"data-name": "Path 37956",
				d: "M381.207,1199.37c.275.132.351.27.8.478.418.192.551.165.663.3.141.169.2.532-.24,1.408a.779.779,0,0,1,.869-.123.489.489,0,0,1,.155.216c.133.4-.279.8-1.079.934a2.733,2.733,0,0,1-2.581.775c-1.395-.343-1.039-3.544-.018-4.056a1.348,1.348,0,0,1,.586-.116,1.982,1.982,0,0,1,.838.184",
				transform: "translate(-378.881 -1199.186)",
				fill: "#f7cfa8"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-38",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15538",
				"data-name": "Path 15538",
				d: "M1880.994,1067.388a15.421,15.421,0,0,1,13.956-15.262,12.8,12.8,0,0,1,14.213,12.659,15.431,15.431,0,0,1-13.8,15.247c-.473.046-.942.069-1.4.069a12.746,12.746,0,0,1-12.965-12.714m15.52-28.487-3.518.288a2.024,2.024,0,0,0-1.845,2.007l.034,2.267a24.979,24.979,0,0,0-4.635,1.6l.583-2.422c-.533-.846-3.442-.487-4.336.1l-3.053,2.008a1.924,1.924,0,0,0-.655,2.6l1.148,1.815a26.372,26.372,0,0,0-3.449,3.673l.021-1.2c-.916-.437-4.01.255-4.521,1.193l-1.746,3.2a1.767,1.767,0,0,0,.734,2.491l1.83.867a24.305,24.305,0,0,0-1.293,4.854l-2.026.184a2.075,2.075,0,0,0-1.879,2.044l.052,3.522a1.722,1.722,0,0,0,1.935,1.692l1.913-.179a21.589,21.589,0,0,0,1.318,4.744l-1.572,1.051a1.941,1.941,0,0,0-.659,2.62l1.837,2.871c.538.842,2.958,1.239,3.858.635l.234-1.2a20.914,20.914,0,0,0,3.667,3.275l-.815,1.509a1.752,1.752,0,0,0,.73,2.475l3.1,1.44c.909.422,3.791.354,4.3-.588l-.954-1.8a22.349,22.349,0,0,0,5.011.834l.023,1.561a1.681,1.681,0,0,0,1.9,1.661l3.517-.361a2.069,2.069,0,0,0,1.837-2.04l-.023-1.556a25.065,25.065,0,0,0,4.924-1.833l.809,1.28c.525.83,3.515,1.124,4.393.525l1.137-2.146a1.933,1.933,0,0,0,.638-2.582l-.837-1.327a26.29,26.29,0,0,0,3.468-3.932l1.468.7c.887.421,3.459.532,3.953-.4l.23-3.682a1.744,1.744,0,0,0-.709-2.441l-1.543-.737a24.144,24.144,0,0,0,1.132-4.89l1.843-.173a2.018,2.018,0,0,0,1.8-2l-.051-3.449a1.675,1.675,0,0,0-1.859-1.666l-1.951.177a21.483,21.483,0,0,0-1.385-4.531l1.737-1.166a1.916,1.916,0,0,0,.634-2.565l.173-3.438c-.52-.834-3.594-.441-4.466.142l-1.828,1.221a20.9,20.9,0,0,0-3.461-3.036l1.066-1.981a1.76,1.76,0,0,0-.713-2.457l-1.381-1.8c-.893-.436-3.682.281-4.181,1.206l-1.1,2.03a22.3,22.3,0,0,0-4.628-.82l-.033-2.261a1.71,1.71,0,0,0-1.737-1.7c-.051,0-.1,0-.155.006",
				transform: "translate(-1867.906 -1038.894)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-39",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15539",
				"data-name": "Path 15539",
				d: "M1911.538,1065.507a15.421,15.421,0,0,1,13.956-15.262,12.8,12.8,0,0,1,14.213,12.659,15.43,15.43,0,0,1-13.8,15.247c-.473.046-.942.069-1.4.069a12.746,12.746,0,0,1-12.965-12.714m15.52-28.487-3.518.288a2.024,2.024,0,0,0-1.845,2.007l.034,2.267a24.955,24.955,0,0,0-4.635,1.6l-1.169-1.854a1.834,1.834,0,0,0-2.584-.467l-3.053,2.008a1.924,1.924,0,0,0-.655,2.6l1.148,1.815a26.365,26.365,0,0,0-3.449,3.673l-1.915-.914a2.016,2.016,0,0,0-2.585.907l-1.747,3.2a1.768,1.768,0,0,0,.735,2.491l1.83.868a24.289,24.289,0,0,0-1.293,4.854l-2.026.184a2.075,2.075,0,0,0-1.879,2.044l.052,3.522a1.723,1.723,0,0,0,1.935,1.692l1.913-.179a21.608,21.608,0,0,0,1.318,4.743l-1.572,1.051a1.941,1.941,0,0,0-.659,2.62l1.836,2.871a1.841,1.841,0,0,0,2.6.429l1.488-1a20.917,20.917,0,0,0,3.667,3.275l-.815,1.509a1.751,1.751,0,0,0,.73,2.475l3.1,1.44a2.018,2.018,0,0,0,2.563-.942l.78-1.45a22.351,22.351,0,0,0,5.011.834l.023,1.561a1.681,1.681,0,0,0,1.9,1.662l3.517-.361a2.069,2.069,0,0,0,1.837-2.04l-.023-1.556a25.069,25.069,0,0,0,4.924-1.833l.809,1.28a1.781,1.781,0,0,0,2.541.418l2.989-2.039a1.932,1.932,0,0,0,.638-2.582l-.837-1.328a26.29,26.29,0,0,0,3.468-3.932l1.469.7a1.95,1.95,0,0,0,2.5-.918l1.683-3.159a1.744,1.744,0,0,0-.708-2.441l-1.543-.737a24.129,24.129,0,0,0,1.132-4.89l1.843-.173a2.018,2.018,0,0,0,1.8-2l-.051-3.449a1.674,1.674,0,0,0-1.858-1.666l-1.951.177a21.482,21.482,0,0,0-1.384-4.531l1.736-1.166a1.916,1.916,0,0,0,.635-2.565l-1.772-2.84a1.773,1.773,0,0,0-2.521-.455l-1.828,1.222a20.918,20.918,0,0,0-3.46-3.037l1.066-1.981a1.76,1.76,0,0,0-.713-2.457l-3.041-1.483a1.948,1.948,0,0,0-2.522.885l-1.1,2.03a22.3,22.3,0,0,0-4.628-.82l-.033-2.261a1.711,1.711,0,0,0-1.737-1.7c-.052,0-.1,0-.156.006",
				transform: "translate(-1898.45 -1037.013)",
				fill: "#fff",
				stroke: "#182975",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-40",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15538-2",
				"data-name": "Path 15538",
				d: "M1877.1,1058.906a10.83,10.83,0,0,1,9.8-10.719,8.988,8.988,0,0,1,9.982,8.891,10.837,10.837,0,0,1-9.692,10.708c-.332.033-.662.048-.986.048a8.952,8.952,0,0,1-9.105-8.929M1888,1038.9l-2.471.2a1.421,1.421,0,0,0-1.3,1.41l.024,1.592a17.543,17.543,0,0,0-3.255,1.124l.41-1.7c-.375-.594-2.418-.342-3.046.071l-2.145,1.41a1.351,1.351,0,0,0-.46,1.827l.806,1.275a18.52,18.52,0,0,0-2.422,2.58l.015-.843c-.643-.307-2.816.179-3.176.838l-1.227,2.249a1.241,1.241,0,0,0,.516,1.75l1.285.609a17.071,17.071,0,0,0-.908,3.409l-1.423.129a1.457,1.457,0,0,0-1.32,1.436l.037,2.474a1.21,1.21,0,0,0,1.359,1.188l1.344-.126a15.164,15.164,0,0,0,.926,3.331l-1.1.738a1.363,1.363,0,0,0-.463,1.84l1.29,2.016a2.6,2.6,0,0,0,2.71.446l.165-.846a14.7,14.7,0,0,0,2.575,2.3l-.572,1.06a1.23,1.23,0,0,0,.513,1.738l2.18,1.011c.639.3,2.663.248,3.018-.413l-.67-1.266a15.694,15.694,0,0,0,3.519.586l.016,1.1a1.181,1.181,0,0,0,1.334,1.167l2.47-.254a1.453,1.453,0,0,0,1.29-1.433l-.016-1.093a17.6,17.6,0,0,0,3.458-1.287l.568.9c.369.583,2.468.79,3.085.369l.8-1.507a1.358,1.358,0,0,0,.448-1.813l-.588-.932a18.461,18.461,0,0,0,2.435-2.761l1.031.489c.623.3,2.429.374,2.776-.278l.162-2.586a1.225,1.225,0,0,0-.5-1.714l-1.084-.517a16.949,16.949,0,0,0,.8-3.434l1.294-.121a1.417,1.417,0,0,0,1.267-1.407l-.036-2.422a1.176,1.176,0,0,0-1.305-1.17l-1.37.125a15.087,15.087,0,0,0-.973-3.182l1.22-.819a1.346,1.346,0,0,0,.445-1.8l.122-2.415c-.365-.586-2.524-.31-3.136.1l-1.284.858a14.684,14.684,0,0,0-2.43-2.132l.749-1.391a1.236,1.236,0,0,0-.5-1.725l-.97-1.267a3.317,3.317,0,0,0-2.937.847l-.77,1.425a15.658,15.658,0,0,0-3.25-.576l-.023-1.588a1.2,1.2,0,0,0-1.22-1.2c-.036,0-.073,0-.109,0",
				transform: "translate(-1867.906 -1038.894)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-41",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15539-2",
				"data-name": "Path 15539",
				d: "M1907.642,1057.024a10.83,10.83,0,0,1,9.8-10.719,8.988,8.988,0,0,1,9.982,8.891,10.837,10.837,0,0,1-9.692,10.708c-.332.032-.662.048-.986.048a8.952,8.952,0,0,1-9.106-8.929m10.9-20.007-2.471.2a1.421,1.421,0,0,0-1.3,1.41l.024,1.592a17.521,17.521,0,0,0-3.255,1.124l-.821-1.3a1.288,1.288,0,0,0-1.815-.328l-2.144,1.41a1.351,1.351,0,0,0-.46,1.828l.807,1.275a18.513,18.513,0,0,0-2.422,2.58l-1.345-.642a1.416,1.416,0,0,0-1.816.637l-1.227,2.249a1.242,1.242,0,0,0,.516,1.75l1.285.609a17.056,17.056,0,0,0-.908,3.409l-1.423.129a1.457,1.457,0,0,0-1.32,1.436l.037,2.474a1.21,1.21,0,0,0,1.359,1.188l1.344-.126a15.176,15.176,0,0,0,.926,3.331l-1.1.738a1.363,1.363,0,0,0-.463,1.84l1.29,2.016a1.292,1.292,0,0,0,1.829.3l1.045-.7a14.685,14.685,0,0,0,2.575,2.3l-.572,1.06a1.23,1.23,0,0,0,.513,1.738l2.18,1.011a1.417,1.417,0,0,0,1.8-.661l.548-1.018a15.7,15.7,0,0,0,3.519.586l.016,1.1a1.181,1.181,0,0,0,1.334,1.167l2.47-.254a1.453,1.453,0,0,0,1.29-1.433l-.016-1.093a17.606,17.606,0,0,0,3.458-1.287l.568.9a1.25,1.25,0,0,0,1.785.294l2.1-1.432a1.357,1.357,0,0,0,.448-1.813l-.588-.932a18.468,18.468,0,0,0,2.435-2.761l1.031.489a1.369,1.369,0,0,0,1.756-.645l1.182-2.219a1.225,1.225,0,0,0-.5-1.714l-1.084-.517a16.935,16.935,0,0,0,.8-3.434l1.294-.121a1.417,1.417,0,0,0,1.267-1.407l-.036-2.422a1.176,1.176,0,0,0-1.305-1.17l-1.37.124a15.087,15.087,0,0,0-.972-3.182l1.22-.819a1.346,1.346,0,0,0,.446-1.8l-1.245-1.995a1.246,1.246,0,0,0-1.77-.32l-1.284.858a14.69,14.69,0,0,0-2.43-2.133l.748-1.391a1.236,1.236,0,0,0-.5-1.725l-2.135-1.041a1.368,1.368,0,0,0-1.771.622l-.769,1.425a15.681,15.681,0,0,0-3.25-.576l-.024-1.588a1.2,1.2,0,0,0-1.22-1.2c-.036,0-.072,0-.109,0",
				transform: "translate(-1898.45 -1037.013)",
				fill: "#fff",
				stroke: "#182975",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-42",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16425",
				"data-name": "Rectangle 16425",
				width: 85,
				height: 84,
				transform: "translate(-0.1 -0.327)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-43",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15351",
				"data-name": "Path 15351",
				d: "M378.011,729.376c0,18.751,15.619,33.952,34.887,33.952s34.887-15.2,34.887-33.952-15.619-33.952-34.887-33.952-34.887,15.2-34.887,33.952",
				transform: "translate(-378.011 -695.424)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "linear-gradient-20",
			x1: -.152,
			y1: 1.807,
			x2: -.151,
			y2: 1.807,
			gradientUnits: "objectBoundingBox",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				stopColor: "#cb236d"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4c246d"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-44",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13104",
				"data-name": "Rectangle 13104",
				width: 216.739,
				height: 212.047,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-45",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13103",
				"data-name": "Rectangle 13103",
				width: 57.141,
				height: 55.609,
				fill: "#fff"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-46",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15390",
				"data-name": "Path 15390",
				d: "M0,0,7.19.1l.791,59.2-7.19-.1Z",
				transform: "translate(0 5.066) rotate(-39.406)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-21",
			x1: -.464,
			y1: 2.405,
			x2: -.463,
			y2: 2.405,
			xlinkHref: "#linear-gradient-20"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-47",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_16426",
				"data-name": "Rectangle 16426",
				width: 97.578,
				height: 78.476,
				transform: "translate(0 0)",
				fill: "#fff",
				stroke: "#707070",
				strokeWidth: 1
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-48",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15621",
				"data-name": "Path 15621",
				d: "M0,0H181.83V177.894H0Z",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-49",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13075",
				"data-name": "Rectangle 13075",
				width: 181.83,
				height: 177.894,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-50",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13097",
				"data-name": "Rectangle 13097",
				width: 76.384,
				height: 61.977,
				rx: 11,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-22",
			x1: -.738,
			y1: .903,
			x2: -.737,
			y2: .903,
			xlinkHref: "#linear-gradient-20"
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-52",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_13098",
				"data-name": "Rectangle 13098",
				width: 68.661,
				height: 48.525,
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-task-lock-53",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Path_15349",
				"data-name": "Path 15349",
				d: "M1615.732,1977.418a17.8,17.8,0,1,0,17.792-17.315,17.558,17.558,0,0,0-17.792,17.315",
				transform: "translate(-1615.732 -1960.103)",
				fill: "none"
			})
		}),
		/* @__PURE__ */ _jsx("linearGradient", {
			id: "linear-gradient-23",
			x1: -1.961,
			y1: 1.24,
			x2: -1.96,
			y2: 1.24,
			xlinkHref: "#linear-gradient-20"
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_14136",
		"data-name": "Group 14136",
		transform: "translate(-876.055 -461.682)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_14135",
				"data-name": "Group 14135",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_14128",
					"data-name": "Group 14128",
					transform: "translate(886.445 461.682)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_12056",
						"data-name": "Group 12056",
						clipPath: "url(#clip-path-task-lock)",
						children: [
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11838",
								"data-name": "Group 11838",
								transform: "translate(0 0)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11837",
									"data-name": "Group 11837",
									clipPath: "url(#clip-path-task-lock)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_15200",
										"data-name": "Path 15200",
										d: "M205.516,102.307c3.47,17.7,10.5,53.586-6.327,77.59C168.647,223.462,64.777,220.392,20.9,165.466,17.11,160.717-1.918,135.947.158,102.029,3.759,43.2,68.76-8.95,120.854,1.292c30.488,5.994,50.752,32.217,59.094,43.012,3.438,4.449,19.183,25.423,25.568,58",
										transform: "translate(0 0.002)",
										fill: "#f4f7fa"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11840",
								"data-name": "Group 11840",
								transform: "translate(4.17 26.341)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11839",
									"data-name": "Group 11839",
									clipPath: "url(#clip-path-task-lock-3)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14492",
										"data-name": "Rectangle 14492",
										width: 215.623,
										height: 165.374,
										transform: "translate(-15.007 1.568) rotate(-5.964)",
										fill: "url(#linear-gradient)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11842",
								"data-name": "Group 11842",
								transform: "translate(81.94 156.114)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11841",
									"data-name": "Group 11841",
									clipPath: "url(#clip-path-task-lock-4)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14493",
										"data-name": "Rectangle 14493",
										width: 71.763,
										height: 77.996,
										transform: "translate(-19.879 27.691) rotate(-55.081)",
										fill: "url(#linear-gradient-2)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11844",
								"data-name": "Group 11844",
								transform: "translate(83.207 155.102)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11843",
									"data-name": "Group 11843",
									clipPath: "url(#clip-path-task-lock-5)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14494",
										"data-name": "Rectangle 14494",
										width: 71.042,
										height: 51.725,
										transform: "matrix(0.983, -0.181, 0.181, 0.983, -7.757, 1.335)",
										fill: "url(#linear-gradient-3)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11846",
								"data-name": "Group 11846",
								transform: "translate(5.665 26.341)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11845",
									"data-name": "Group 11845",
									clipPath: "url(#clip-path-task-lock-6)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14495",
										"data-name": "Rectangle 14495",
										width: 234.621,
										height: 248.452,
										transform: "matrix(0.574, -0.819, 0.819, 0.574, -68.241, 97.395)",
										fill: "url(#linear-gradient-4)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11848",
								"data-name": "Group 11848",
								transform: "translate(9.058 29.429)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11847",
									"data-name": "Group 11847",
									clipPath: "url(#clip-path-task-lock-7)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14496",
										"data-name": "Rectangle 14496",
										width: 191.27,
										height: 228.35,
										transform: "translate(-39.795 126.393) rotate(-72.524)",
										fill: "url(#linear-gradient-5)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11850",
								"data-name": "Group 11850",
								transform: "translate(11.424 31.59)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11849",
									"data-name": "Group 11849",
									clipPath: "url(#clip-path-task-lock-8)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14497",
										"data-name": "Rectangle 14497",
										width: 192.804,
										height: 226.048,
										transform: "matrix(0.409, -0.912, 0.912, 0.409, -46.831, 104.428)",
										fill: "url(#linear-gradient-6)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11852",
								"data-name": "Group 11852",
								transform: "translate(21.218 38.121)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11851",
									"data-name": "Group 11851",
									clipPath: "url(#clip-path-task-lock-9)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14498",
										"data-name": "Rectangle 14498",
										width: 33.27,
										height: 174.345,
										transform: "translate(-1.486 12.299) rotate(-83.112)",
										fill: "url(#linear-gradient-7)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11854",
								"data-name": "Group 11854",
								transform: "translate(180.22 45.528)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11853",
									"data-name": "Group 11853",
									clipPath: "url(#clip-path-task-lock-10)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14499",
										"data-name": "Rectangle 14499",
										width: 2.563,
										height: 2.531,
										transform: "translate(-0.752 1.592) rotate(-64.722)",
										fill: "url(#linear-gradient-8)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11856",
								"data-name": "Group 11856",
								transform: "translate(184.084 45.631)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11855",
									"data-name": "Group 11855",
									clipPath: "url(#clip-path-task-lock-11)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14500",
										"data-name": "Rectangle 14500",
										width: 2.554,
										height: 2.519,
										transform: "translate(-0.75 1.588) rotate(-64.722)",
										fill: "url(#linear-gradient-9)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_11858",
								"data-name": "Group 11858",
								transform: "translate(187.926 45.734)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_11857",
									"data-name": "Group 11857",
									clipPath: "url(#clip-path-task-lock-12)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14501",
										"data-name": "Rectangle 14501",
										width: 2.544,
										height: 2.507,
										transform: "translate(-0.748 1.583) rotate(-64.722)",
										fill: "url(#linear-gradient-10)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_12049",
								"data-name": "Group 12049",
								transform: "translate(127.667 140.117)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12048",
									"data-name": "Group 12048",
									clipPath: "url(#clip-path-task-lock-19)",
									children: /* @__PURE__ */ _jsx("rect", {
										id: "Rectangle_14583",
										"data-name": "Rectangle 14583",
										width: 91.159,
										height: 73.007,
										transform: "translate(-9.932 1.69) rotate(-9.657)",
										fill: "#7284fa"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_12051",
								"data-name": "Group 12051",
								transform: "translate(127.125 140.116)",
								children: /* @__PURE__ */ _jsxs("g", {
									id: "Group_12050",
									"data-name": "Group 12050",
									clipPath: "url(#clip-path-task-lock-20)",
									children: [
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15290",
											"data-name": "Path 15290",
											d: "M1754.432,1975.007a73.93,73.93,0,0,1-11.65-.924l.041-.256a74.7,74.7,0,0,0,44.1-6.524,90.317,90.317,0,0,0,34.261-29.321l.211.15a90.577,90.577,0,0,1-34.36,29.4,75.581,75.581,0,0,1-32.607,7.47",
											transform: "translate(-1742.558 -1936.486)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15291",
											"data-name": "Path 15291",
											d: "M2002.109,2454.393c-4.926-6.586-15.588-14.149-23.767-16.858l.081-.246c8.222,2.723,18.94,10.326,23.893,16.949Z",
											transform: "translate(-1960.905 -2399.308)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15292",
											"data-name": "Path 15292",
											d: "M1822.478,2160.4l-.032-.257c4.438-.547,8.431-3.318,11.866-8.237a50.964,50.964,0,0,0,6.442-13.851l.247.078a51.224,51.224,0,0,1-6.477,13.921c-3.479,4.981-7.532,7.789-12.047,8.346",
											transform: "translate(-1816.401 -2121.939)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15293",
											"data-name": "Path 15293",
											d: "M2394.661,2327.336c-5.28-3.352-13.307-7.043-21.566-5.59l-.044-.255c8.34-1.466,16.431,2.25,21.749,5.626Z",
											transform: "translate(-2326.772 -2291.666)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15294",
											"data-name": "Path 15294",
											d: "M2592.74,1893.577l-.2-.164c2.582-3.167,6.795-10.322,6.008-22.662l.258-.016c.793,12.429-3.46,19.646-6.065,22.842",
											transform: "translate(-2530.222 -1874.153)",
											fill: "#fcfdfe"
										})
									]
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_12053",
								"data-name": "Group 12053",
								transform: "translate(128.98 116.408)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_12052",
									"data-name": "Group 12052",
									clipPath: "url(#clip-path-task-lock-21)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_39235",
										"data-name": "Path 39235",
										d: "M0,0H99.86V99.692H0Z",
										transform: "matrix(0.62, -0.785, 0.785, 0.62, -34.797, 44.075)",
										fill: "#cfd5fa"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_12055",
								"data-name": "Group 12055",
								transform: "translate(128.98 116.408)",
								children: /* @__PURE__ */ _jsxs("g", {
									id: "Group_12054",
									"data-name": "Group 12054",
									clipPath: "url(#clip-path-task-lock-22)",
									children: [
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15297",
											"data-name": "Path 15297",
											d: "M1762.969,1624.247l-.226-.126a307.183,307.183,0,0,1,28.274-29.387c2.328-2.3,4.746-4.583,7.084-6.792,13.02-12.3,25.318-23.923,28.443-42.417l.255.043c-3.139,18.579-15.468,30.229-28.521,42.562-2.337,2.208-4.754,4.492-7.084,6.793a305.107,305.107,0,0,0-28.226,29.325",
											transform: "translate(-1762.916 -1548.996)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15298",
											"data-name": "Path 15298",
											d: "M2409.456,1834.866l-.089-.243c6.775-2.489,15.488-6.511,20.168-8.672,3.786-1.748,3.8-1.742,3.9-1.661l-.155.208.077-.1v.127c-.17.027-1.736.75-3.719,1.665-4.684,2.162-13.4,6.187-20.188,8.68",
											transform: "translate(-2362.289 -1807.369)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15299",
											"data-name": "Path 15299",
											d: "M2460.791,1646.709l-.245-.083c3.691-10.962-.53-18.409-1.1-18.858l.062-.079-.017-.162c.078-.009.134.043.212.14,1.116,1.394,4.571,8.711,1.093,19.042",
											transform: "translate(-2408.705 -1625.008)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15300",
											"data-name": "Path 15300",
											d: "M2017.942,1962.414l-.213-.147c7.005-10.144,4.986-24.126,3.794-29.666a4.307,4.307,0,0,1-.086-.439l.259-.01-.129.005.129-.006c0,.032.039.2.081.4,1.2,5.573,3.229,19.641-3.833,29.868",
											transform: "translate(-1999.269 -1907.372)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15301",
											"data-name": "Path 15301",
											d: "M2080.923,2253.7l-.131-.223c8.532-5.008,18.516-.387,18.586-.323l.029.152-.138.071.021-.127-.067.109c-.091-.051-9.884-4.6-18.3.34",
											transform: "translate(-2057.724 -2203.059)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15302",
											"data-name": "Path 15302",
											d: "M1792.407,2404.17l-.224-.13c1.241-2.154,2.432-6.315,1.064-13.905-.077-.43-.077-.43-.038-.485l.209.152-.1-.076.128.007c0,.031.028.181.06.355,1.382,7.667.168,11.89-1.094,14.081",
											transform: "translate(-1790.204 -2331.442)",
											fill: "#fcfdfe"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15303",
											"data-name": "Path 15303",
											d: "M1836.1,2496.778l-.186-.18c1.376-1.424,5.031-3.707,14.061-2.989.123.01.2.016.231.017l0,.259c-.031,0-.117-.007-.249-.018-8.924-.709-12.511,1.519-13.854,2.911",
											transform: "translate(-1830.743 -2427.677)",
											fill: "#fcfdfe"
										})
									]
								})
							})
						]
					})
				}), /* @__PURE__ */ _jsxs("g", {
					id: "Group_13389",
					"data-name": "Group 13389",
					transform: "translate(1068.506 563.891)",
					children: [
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13352",
							"data-name": "Group 13352",
							transform: "translate(29.459 104.729)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13351",
								"data-name": "Group 13351",
								clipPath: "url(#clip-path-task-lock-23)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16407",
									"data-name": "Rectangle 16407",
									width: 4.57,
									height: 7.57,
									transform: "translate(0.187 4.606) rotate(-100.906)",
									fill: "url(#linear-gradient-11)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13354",
							"data-name": "Group 13354",
							transform: "translate(34.517 102.926)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13353",
								"data-name": "Group 13353",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-24)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16408",
									"data-name": "Rectangle 16408",
									width: 2.315,
									height: 2.937,
									transform: "translate(2.053 2.948) rotate(-174.735)",
									fill: "#f7cfa8"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13356",
							"data-name": "Group 13356",
							transform: "translate(41.706 107.547)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13355",
								"data-name": "Group 13355",
								clipPath: "url(#clip-path-task-lock-25)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16409",
									"data-name": "Rectangle 16409",
									width: 4.57,
									height: 7.57,
									transform: "translate(0.187 4.606) rotate(-100.906)",
									fill: "url(#linear-gradient-12)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13358",
							"data-name": "Group 13358",
							transform: "translate(46.764 105.743)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13357",
								"data-name": "Group 13357",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-26)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16410",
									"data-name": "Rectangle 16410",
									width: 2.315,
									height: 2.937,
									transform: "translate(2.053 2.948) rotate(-174.735)",
									fill: "#f7cfa8"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13360",
							"data-name": "Group 13360",
							transform: "translate(32.57 45.658)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13359",
								"data-name": "Group 13359",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-27)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16411",
									"data-name": "Rectangle 16411",
									width: 17.269,
									height: 58.936,
									transform: "matrix(-0.997, -0.08, 0.08, -0.997, 12.443, 59.119)",
									fill: "url(#linear-gradient-13)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13369",
							"data-name": "Group 13369",
							transform: "translate(40.032 47.2)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13368",
								"data-name": "Group 13368",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-28)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16415",
									"data-name": "Rectangle 16415",
									width: 19.201,
									height: 60.738,
									transform: "matrix(-0.997, -0.08, 0.08, -0.997, 14.379, 60.925)",
									fill: "url(#linear-gradient-14)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13380",
							"data-name": "Group 13380",
							transform: "translate(51.517 47.363)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13379",
								"data-name": "Group 13379",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-29)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16420",
									"data-name": "Rectangle 16420",
									width: 6.486,
									height: 3.317,
									transform: "matrix(-0.997, -0.08, 0.08, -0.997, 6.216, 3.324)",
									fill: "#f7cfa8"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13254",
							"data-name": "Group 13254",
							transform: "translate(12.448 26.515)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13253",
								"data-name": "Group 13253",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-30)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16362",
									"data-name": "Rectangle 16362",
									width: .945,
									height: .851,
									transform: "translate(0.147 1.038) rotate(-123.641)",
									fill: "url(#linear-gradient-15)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13348",
							"data-name": "Group 13348",
							transform: "translate(0 6.232)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13347",
								"data-name": "Group 13347",
								clipPath: "url(#clip-path-task-lock-31)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16405",
									"data-name": "Rectangle 16405",
									width: 8.927,
									height: 10.25,
									transform: "matrix(-0.337, -0.941, 0.941, -0.337, 0.914, 9.132)",
									fill: "#f7cfa8"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13350",
							"data-name": "Group 13350",
							transform: "translate(4.954 8.695)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13349",
								"data-name": "Group 13349",
								clipPath: "url(#clip-path-task-lock-32)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16406",
									"data-name": "Rectangle 16406",
									width: 43.661,
									height: 32.67,
									transform: "matrix(-0.949, -0.315, 0.315, -0.949, 35.006, 33.143)",
									fill: "url(#linear-gradient-16)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13371",
							"data-name": "Group 13371",
							transform: "translate(29.007 11.485)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13370",
								"data-name": "Group 13370",
								clipPath: "url(#clip-path-task-lock-33)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16416",
									"data-name": "Rectangle 16416",
									width: 56.606,
									height: 52.039,
									transform: "translate(7.842 60.596) rotate(-120.276)",
									fill: "url(#linear-gradient-17)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13382",
							"data-name": "Group 13382",
							transform: "translate(51.718 12.688)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13381",
								"data-name": "Group 13381",
								clipPath: "url(#clip-path-task-lock-34)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16421",
									"data-name": "Rectangle 16421",
									width: 49.145,
									height: 34.781,
									transform: "translate(8.19 52.658) rotate(-120.276)",
									fill: "url(#linear-gradient-18)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13384",
							"data-name": "Group 13384",
							transform: "translate(37.214 5.834)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13383",
								"data-name": "Group 13383",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-35)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16422",
									"data-name": "Rectangle 16422",
									width: 14.877,
									height: 14.588,
									transform: "matrix(-0.737, -0.675, 0.675, -0.737, 6.259, 14.451)",
									fill: "#f7cfa8"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13386",
							"data-name": "Group 13386",
							transform: "translate(39.243)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13385",
								"data-name": "Group 13385",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-36)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16423",
									"data-name": "Rectangle 16423",
									width: 9.195,
									height: 8.879,
									transform: "translate(0.268 9.431) rotate(-106.908)",
									fill: "url(#linear-gradient-19)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_13388",
							"data-name": "Group 13388",
							transform: "translate(39.66 4.218)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_13387",
								"data-name": "Group 13387",
								transform: "translate(0)",
								clipPath: "url(#clip-path-task-lock-37)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_16424",
									"data-name": "Rectangle 16424",
									width: 6.901,
									height: 6.862,
									transform: "matrix(-0.737, -0.675, 0.675, -0.737, 2.345, 7.138)",
									fill: "#f7cfa8"
								})
							})
						})
					]
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_14129",
				"data-name": "Group 14129",
				transform: "translate(876.055 513.475)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_5340",
					"data-name": "Group 5340",
					transform: "translate(0 0)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_5341",
						"data-name": "Group 5341",
						transform: "translate(0 0)",
						children: [/* @__PURE__ */ _jsx("g", {
							id: "Group_5125",
							"data-name": "Group 5125",
							transform: "translate(0 0.145)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_5124",
								"data-name": "Group 5124",
								clipPath: "url(#clip-path-task-lock-38)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_13234",
									"data-name": "Rectangle 13234",
									width: 73.455,
									height: 73.512,
									transform: "translate(-23.157 40.616) rotate(-60.326)",
									fill: "#c6cefc"
								})
							})
						}), /* @__PURE__ */ _jsx("g", {
							id: "Group_5127",
							"data-name": "Group 5127",
							transform: "translate(2.36)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_5126",
								"data-name": "Group 5126",
								clipPath: "url(#clip-path-task-lock-39)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_13235",
									"data-name": "Rectangle 13235",
									width: 73.455,
									height: 73.512,
									transform: "translate(-23.157 40.616) rotate(-60.326)",
									fill: "#fff"
								})
							})
						})]
					})
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_15620",
					"data-name": "Path 15620",
					d: "M1911.538,1065.507a15.421,15.421,0,0,1,13.956-15.262,12.8,12.8,0,0,1,14.213,12.659,15.43,15.43,0,0,1-13.8,15.247c-.473.046-.942.069-1.4.069a12.746,12.746,0,0,1-12.965-12.714m15.52-28.487-3.518.288a2.024,2.024,0,0,0-1.845,2.007l.034,2.267a24.955,24.955,0,0,0-4.635,1.6l-1.169-1.854a1.834,1.834,0,0,0-2.584-.467l-3.053,2.008a1.924,1.924,0,0,0-.655,2.6l1.148,1.815a26.365,26.365,0,0,0-3.449,3.673l-1.915-.914a2.016,2.016,0,0,0-2.585.907l-1.747,3.2a1.768,1.768,0,0,0,.735,2.491l1.83.868a24.289,24.289,0,0,0-1.293,4.854l-2.026.184a2.075,2.075,0,0,0-1.879,2.044l.052,3.522a1.723,1.723,0,0,0,1.935,1.692l1.913-.179a21.608,21.608,0,0,0,1.318,4.743l-1.572,1.051a1.941,1.941,0,0,0-.659,2.62l1.836,2.871a1.841,1.841,0,0,0,2.6.429l1.488-1a20.917,20.917,0,0,0,3.667,3.275l-.815,1.509a1.751,1.751,0,0,0,.73,2.475l3.1,1.44a2.018,2.018,0,0,0,2.563-.942l.78-1.45a22.351,22.351,0,0,0,5.011.834l.023,1.561a1.681,1.681,0,0,0,1.9,1.662l3.517-.361a2.069,2.069,0,0,0,1.837-2.04l-.023-1.556a25.069,25.069,0,0,0,4.924-1.833l.809,1.28a1.781,1.781,0,0,0,2.541.418l2.989-2.039a1.932,1.932,0,0,0,.638-2.582l-.837-1.328a26.29,26.29,0,0,0,3.468-3.932l1.469.7a1.95,1.95,0,0,0,2.5-.918l1.683-3.159a1.744,1.744,0,0,0-.708-2.441l-1.543-.737a24.129,24.129,0,0,0,1.132-4.89l1.843-.173a2.018,2.018,0,0,0,1.8-2l-.051-3.449a1.674,1.674,0,0,0-1.858-1.666l-1.951.177a21.482,21.482,0,0,0-1.384-4.531l1.736-1.166a1.916,1.916,0,0,0,.635-2.565l-1.772-2.84a1.773,1.773,0,0,0-2.521-.455l-1.828,1.222a20.918,20.918,0,0,0-3.46-3.037l1.066-1.981a1.76,1.76,0,0,0-.713-2.457l-3.041-1.483a1.948,1.948,0,0,0-2.522.885l-1.1,2.03a22.3,22.3,0,0,0-4.628-.82l-.033-2.261a1.711,1.711,0,0,0-1.737-1.7c-.052,0-.1,0-.156.006",
					transform: "translate(-1896.09 -1037.013)",
					fill: "#fff",
					stroke: "#182975",
					strokeWidth: 1.5
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_14130",
				"data-name": "Group 14130",
				transform: "translate(924.166 479.477)",
				children: [/* @__PURE__ */ _jsx("g", {
					id: "Group_5340-2",
					"data-name": "Group 5340",
					transform: "translate(0 0)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_5341-2",
						"data-name": "Group 5341",
						transform: "translate(0 0)",
						children: [/* @__PURE__ */ _jsx("g", {
							id: "Group_5125-2",
							"data-name": "Group 5125",
							transform: "translate(0 0.102)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_5124-2",
								"data-name": "Group 5124",
								clipPath: "url(#clip-path-task-lock-40)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_13234-2",
									"data-name": "Rectangle 13234",
									width: 51.589,
									height: 51.628,
									transform: "translate(-16.264 28.525) rotate(-60.326)",
									fill: "#c6cefc"
								})
							})
						}), /* @__PURE__ */ _jsx("g", {
							id: "Group_5127-2",
							"data-name": "Group 5127",
							transform: "translate(1.658)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_5126-2",
								"data-name": "Group 5126",
								clipPath: "url(#clip-path-task-lock-41)",
								children: /* @__PURE__ */ _jsx("rect", {
									id: "Rectangle_13235-2",
									"data-name": "Rectangle 13235",
									width: 51.589,
									height: 51.628,
									transform: "translate(-16.264 28.525) rotate(-60.326)",
									fill: "#fff"
								})
							})
						})]
					})
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_15620-2",
					"data-name": "Path 15620",
					d: "M1907.642,1057.024a10.83,10.83,0,0,1,9.8-10.719,8.988,8.988,0,0,1,9.982,8.891,10.837,10.837,0,0,1-9.692,10.708c-.332.032-.662.048-.986.048a8.952,8.952,0,0,1-9.106-8.929m10.9-20.007-2.471.2a1.421,1.421,0,0,0-1.3,1.41l.024,1.592a17.521,17.521,0,0,0-3.255,1.124l-.821-1.3a1.288,1.288,0,0,0-1.815-.328l-2.144,1.41a1.351,1.351,0,0,0-.46,1.828l.807,1.275a18.513,18.513,0,0,0-2.422,2.58l-1.345-.642a1.416,1.416,0,0,0-1.816.637l-1.227,2.249a1.242,1.242,0,0,0,.516,1.75l1.285.609a17.056,17.056,0,0,0-.908,3.409l-1.423.129a1.457,1.457,0,0,0-1.32,1.436l.037,2.474a1.21,1.21,0,0,0,1.359,1.188l1.344-.126a15.176,15.176,0,0,0,.926,3.331l-1.1.738a1.363,1.363,0,0,0-.463,1.84l1.29,2.016a1.292,1.292,0,0,0,1.829.3l1.045-.7a14.685,14.685,0,0,0,2.575,2.3l-.572,1.06a1.23,1.23,0,0,0,.513,1.738l2.18,1.011a1.417,1.417,0,0,0,1.8-.661l.548-1.018a15.7,15.7,0,0,0,3.519.586l.016,1.1a1.181,1.181,0,0,0,1.334,1.167l2.47-.254a1.453,1.453,0,0,0,1.29-1.433l-.016-1.093a17.606,17.606,0,0,0,3.458-1.287l.568.9a1.25,1.25,0,0,0,1.785.294l2.1-1.432a1.357,1.357,0,0,0,.448-1.813l-.588-.932a18.468,18.468,0,0,0,2.435-2.761l1.031.489a1.369,1.369,0,0,0,1.756-.645l1.182-2.219a1.225,1.225,0,0,0-.5-1.714l-1.084-.517a16.935,16.935,0,0,0,.8-3.434l1.294-.121a1.417,1.417,0,0,0,1.267-1.407l-.036-2.422a1.176,1.176,0,0,0-1.305-1.17l-1.37.124a15.087,15.087,0,0,0-.972-3.182l1.22-.819a1.346,1.346,0,0,0,.446-1.8l-1.245-1.995a1.246,1.246,0,0,0-1.77-.32l-1.284.858a14.69,14.69,0,0,0-2.43-2.133l.748-1.391a1.236,1.236,0,0,0-.5-1.725l-2.135-1.041a1.368,1.368,0,0,0-1.771.622l-.769,1.425a15.681,15.681,0,0,0-3.25-.576l-.024-1.588a1.2,1.2,0,0,0-1.22-1.2c-.036,0-.072,0-.109,0",
					transform: "translate(-1896.793 -1037.013)",
					fill: "#fff",
					stroke: "#182975",
					strokeWidth: 1.5
				})]
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Mask_Group_3",
				"data-name": "Mask Group 3",
				transform: "translate(950.006 521.898)",
				clipPath: "url(#clip-path-task-lock-42)",
				children: /* @__PURE__ */ _jsxs("g", {
					id: "Group_14134",
					"data-name": "Group 14134",
					transform: "translate(-22.846 -45.785)",
					children: [
						/* @__PURE__ */ _jsx("g", {
							id: "Group_14131",
							"data-name": "Group 14131",
							transform: "translate(29.415 52.665)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_4774",
								"data-name": "Group 4774",
								clipPath: "url(#clip-path-task-lock-43)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_15386",
									"data-name": "Path 15386",
									d: "M0,0,97.377,1.316l1.316,97.153L1.316,97.153Z",
									transform: "translate(-34.762 31.082) rotate(-42.576)",
									fill: "url(#linear-gradient-20)"
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_14132",
							"data-name": "Group 14132",
							transform: "translate(0 0)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_4779",
								"data-name": "Group 4779",
								clipPath: "url(#clip-path-task-lock-44)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_4778",
									"data-name": "Group 4778",
									transform: "translate(36.242 58.613)",
									opacity: .9,
									children: /* @__PURE__ */ _jsx("g", {
										id: "Group_4777",
										"data-name": "Group 4777",
										children: /* @__PURE__ */ _jsx("g", {
											id: "Group_4776",
											"data-name": "Group 4776",
											clipPath: "url(#clip-path-task-lock-45)",
											children: /* @__PURE__ */ _jsx("path", {
												id: "Path_15352",
												"data-name": "Path 15352",
												d: "M522.877,801.761c0,15.356-12.791,27.8-28.57,27.8s-28.57-12.449-28.57-27.8,12.791-27.8,28.57-27.8,28.57,12.449,28.57,27.8",
												transform: "translate(-465.736 -773.956)",
												fill: "#fff"
											})
										})
									})
								})
							})
						}),
						/* @__PURE__ */ _jsx("g", {
							id: "Group_14133",
							"data-name": "Group 14133",
							transform: "translate(41.794 61.954)",
							children: /* @__PURE__ */ _jsx("g", {
								id: "Group_4785",
								"data-name": "Group 4785",
								transform: "translate(0 0)",
								clipPath: "url(#clip-path-task-lock-46)",
								children: /* @__PURE__ */ _jsx("path", {
									id: "Path_15389",
									"data-name": "Path 15389",
									d: "M0,0,65.367.861,66.244,67,.876,66.14Z",
									transform: "translate(-24.855 19.685) rotate(-38.309)",
									fill: "url(#linear-gradient-21)"
								})
							})
						})
					]
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Mask_Group_4",
				"data-name": "Mask Group 4",
				transform: "translate(904.195 606.524)",
				clipPath: "url(#clip-path-task-lock-47)",
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4824",
					"data-name": "Group 4824",
					transform: "translate(-73.878 -99.418)",
					children: /* @__PURE__ */ _jsxs("g", {
						id: "Group_2",
						"data-name": "Group 2",
						clipPath: "url(#clip-path-task-lock-48)",
						children: [
							/* @__PURE__ */ _jsx("g", {
								id: "Group_4764",
								"data-name": "Group 4764",
								transform: "translate(84.928 108.585)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_4763",
									"data-name": "Group 4763",
									clipPath: "url(#clip-path-task-lock-50)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_15384",
										"data-name": "Path 15384",
										d: "M0,0,98.373,1.307l1.284,96.131L1.284,96.131Z",
										transform: "translate(-31.235 24.97) rotate(-39.401)",
										fill: "url(#linear-gradient-22)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_4769",
								"data-name": "Group 4769",
								children: /* @__PURE__ */ _jsxs("g", {
									id: "Group_4768",
									"data-name": "Group 4768",
									clipPath: "url(#clip-path-task-lock-49)",
									children: [
										/* @__PURE__ */ _jsx("g", {
											id: "Group_4767",
											"data-name": "Group 4767",
											transform: "translate(88.896 118.421)",
											opacity: .9,
											children: /* @__PURE__ */ _jsx("g", {
												id: "Group_4766",
												"data-name": "Group 4766",
												children: /* @__PURE__ */ _jsx("g", {
													id: "Group_4765",
													"data-name": "Group 4765",
													clipPath: "url(#clip-path-task-lock-52)",
													children: /* @__PURE__ */ _jsx("path", {
														id: "Path_15344",
														"data-name": "Path 15344",
														d: "M1428.356,1863.9h-64.632a1.988,1.988,0,0,0-2.015,1.961v44.6a1.988,1.988,0,0,0,2.015,1.961h64.632a1.988,1.988,0,0,0,2.015-1.961v-44.6a1.988,1.988,0,0,0-2.015-1.961",
														transform: "translate(-1361.71 -1863.904)",
														fill: "#fff"
													})
												})
											})
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15345",
											"data-name": "Path 15345",
											d: "M2102.67,1747.849a2.923,2.923,0,1,1,3-2.922,2.966,2.966,0,0,1-3,2.922m0-5.1a2.181,2.181,0,1,0,2.24,2.18,2.213,2.213,0,0,0-2.24-2.18",
											transform: "translate(-1962.596 -1631.33)",
											fill: "#fcf7f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15346",
											"data-name": "Path 15346",
											d: "M2216.342,1747.849a2.923,2.923,0,1,1,3-2.922,2.966,2.966,0,0,1-3,2.922m0-5.1a2.181,2.181,0,1,0,2.24,2.18,2.213,2.213,0,0,0-2.24-2.18",
											transform: "translate(-2068.847 -1631.33)",
											fill: "#fcf7f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15347",
											"data-name": "Path 15347",
											d: "M2216.649,1747.849a2.923,2.923,0,1,1,3-2.922,2.966,2.966,0,0,1-3,2.922m0-5.1a2.181,2.181,0,1,0,2.24,2.18,2.213,2.213,0,0,0-2.24-2.18",
											transform: "translate(-2069.134 -1631.33)",
											fill: "#fcf7f4"
										}),
										/* @__PURE__ */ _jsx("path", {
											id: "Path_15348",
											"data-name": "Path 15348",
											d: "M2330.324,1747.849a2.923,2.923,0,1,1,3-2.922,2.966,2.966,0,0,1-3,2.922m0-5.1a2.181,2.181,0,1,0,2.24,2.18,2.213,2.213,0,0,0-2.24-2.18",
											transform: "translate(-2175.388 -1631.33)",
											fill: "#fcf7f4"
										})
									]
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_4771",
								"data-name": "Group 4771",
								transform: "translate(105.479 124.532)",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_4770",
									"data-name": "Group 4770",
									clipPath: "url(#clip-path-task-lock-53)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_15385",
										"data-name": "Path 15385",
										d: "M0,0,49.541.658,50.2,49.939.658,49.281Z",
										transform: "translate(-17.453 13.952) rotate(-39.401)",
										fill: "url(#linear-gradient-23)"
									})
								})
							}),
							/* @__PURE__ */ _jsx("g", {
								id: "Group_4773",
								"data-name": "Group 4773",
								children: /* @__PURE__ */ _jsx("g", {
									id: "Group_4772",
									"data-name": "Group 4772",
									clipPath: "url(#clip-path-task-lock-49)",
									children: /* @__PURE__ */ _jsx("path", {
										id: "Path_15350",
										"data-name": "Path 15350",
										d: "M1758.353,2032.97l-.056-.04a2.041,2.041,0,0,0-2.725.147l-1.011,1.224v-9.775a1.519,1.519,0,0,0-1.477-1.657h-.057a1.731,1.731,0,0,0-1.732,1.657v5.935h-.363v-9.542a1.725,1.725,0,0,0-3.447,0v9.542h-.232c.019,0-.131-.16-.131-.264v-7.323a1.489,1.489,0,0,0-1.507-1.595h-.057a1.825,1.825,0,0,0-1.884,1.595v7.323c0,.1-.022.264,0,.264h-.359v-3.623a1.353,1.353,0,0,0-1.431-1.5h-.057a1.646,1.646,0,0,0-1.778,1.5v13.738a5.81,5.81,0,0,0,6.05,5.6h2.716a5.807,5.807,0,0,0,5.9-5.065l4.3-5.708a1.751,1.751,0,0,0-.665-2.434",
										transform: "translate(-1626.451 -1890.977)",
										fill: "#fff"
									})
								})
							})
						]
					})
				})
			})
		]
	})]
});
export default SvgTaskLocked;
